import React, { useState, useEffect } from 'react';
import StreamComponent from './StreamComponent';
import LoginPage from './LoginPage';
import { GaijinAuthService, GaijinUser } from './auth/GaijinAuthService';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState<GaijinUser | null>(null);

    useEffect(() => {
        if (GaijinAuthService.isAuthenticated()) {
            const currentUser = GaijinAuthService.getCurrentUser();
            setUser(currentUser);
            setIsAuthenticated(true);
        }

        const checkAuth = setInterval(() => {
            if (!GaijinAuthService.isAuthenticated()) {
                setUser(null);
                setIsAuthenticated(false);
            }
        }, 60_000);

        const onActivity = () => GaijinAuthService.touchActivity();
        window.addEventListener('mousemove', onActivity);
        window.addEventListener('keydown', onActivity);
        window.addEventListener('click', onActivity);

        return () => {
            clearInterval(checkAuth);
            window.removeEventListener('mousemove', onActivity);
            window.removeEventListener('keydown', onActivity);
            window.removeEventListener('click', onActivity);
        };
    }, []);

    const handleLoginSuccess = () => {
        const currentUser = GaijinAuthService.getCurrentUser();
        setUser(currentUser);
        setIsAuthenticated(true);
    };

    const handleSignOut = () => {
        GaijinAuthService.signOut();
        setUser(null);
        setIsAuthenticated(false);
    };

    if (!isAuthenticated) {
        return <LoginPage onLoginSuccess={handleLoginSuccess} />;
    }

    return (
        <StreamComponent
            signOut={handleSignOut}
            user={user}
            apiEndpoint={API_ENDPOINT}
        />
    );
}

export default App;
